/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface CreateSlackCardNotificationsRequest
 */
export interface CreateSlackCardNotificationsRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateSlackCardNotificationsRequest
     */
    'channelId': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateSlackCardNotificationsRequest
     */
    'transactionTypes': Array<CreateSlackCardNotificationsRequestTransactionTypesEnum>;
    /**
     * 
     * @type {number}
     * @memberof CreateSlackCardNotificationsRequest
     */
    'largeAmountThreshold'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateSlackCardNotificationsRequest
     */
    'userAccountIds': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateSlackCardNotificationsRequest
     */
    'groupIds': Array<string>;
}

export const CreateSlackCardNotificationsRequestTransactionTypesEnum = {
    unknownTransactionType: 'UNKNOWN_TRANSACTION_TYPE',
    successfulTransaction: 'SUCCESSFUL_TRANSACTION',
    incorrectCardInput: 'INCORRECT_CARD_INPUT',
    insufficientBalance: 'INSUFFICIENT_BALANCE',
    otherError: 'OTHER_ERROR',
    potentialFraud: 'POTENTIAL_FRAUD',
    criticalError: 'CRITICAL_ERROR',
    unusualUser: 'UNUSUAL_USER',
    limitationByUser: 'LIMITATION_BY_USER',
    unsupportedTransaction: 'UNSUPPORTED_TRANSACTION',
    carelessUser: 'CARELESS_USER'
} as const;

export type CreateSlackCardNotificationsRequestTransactionTypesEnum = typeof CreateSlackCardNotificationsRequestTransactionTypesEnum[keyof typeof CreateSlackCardNotificationsRequestTransactionTypesEnum];


